import { celcomGenerateToken as apiCelcomGenerateToken } from "@blacknut/javascript-sdk/dist";
import { Dispatch } from "redux";
import { CelcomAction, CelcomActionTypes } from "./Celcom";
/** @deprecated */
export const celcomDismissGenerateTokenError = () => (
  dispatch: Dispatch<CelcomAction>,
) => dispatch({ type: CelcomActionTypes.CELCOM_GENERATE_TOKEN_ERROR });

/** @deprecated */
export const celcomGenerateToken = (planId: string) => {
  return (dispatch: Dispatch<CelcomAction>) => {
    return new Promise<{ token: string; url: string }>((resolve, reject) => {
      dispatch({ type: CelcomActionTypes.CELCOM_GENERATE_TOKEN_REQUEST });
      apiCelcomGenerateToken(planId).subscribe({
        next: ({ token, url }) => {
          dispatch({
            type: CelcomActionTypes.CELCOM_GENERATE_TOKEN_SUCCESS,
            token,
            url,
          });
          resolve({ token, url });
        },
        error: error => {
          dispatch({ type: CelcomActionTypes.CELCOM_GENERATE_TOKEN_ERROR, error });
          reject(error);
        },
      });
    });
  };
};
